import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_POST, CHOOSE_ARTWORK, PROFILE, SETTINGS_PROFILE } from '../../../../constants/routes';
import { useFormik } from 'formik';
import formik from './ProfileForm';
import { Button, ButtonGroup, Form, FormControl, InputGroup } from 'react-bootstrap';
import Avatar from '../../../../components/Avatar';
import { ChangePhotoIcon, DolarSIcon, Locked, BigXCloseBtn, ValidVectorIcon } from '../../../../components/Icons';
import { selectAuthUser } from '../../../../reducers/auth/auth.selectors';
import Loader from '../../../../components/Loader';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as ChangePhoto } from 'images/change-photo.svg';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { NewBackIcon } from 'components/Icons';
import { resolveHookState } from 'react-use/lib/misc/hookState';
import SubscriptionErrorPopup from 'components/SubscriptionErrorPopup';
import { handleDecimalDots } from 'helpers';

const Profile = props => {
  const [showSavePopup, setShowSavePopup] = useState(false);
  const shouldUploadAvatar = props?.location?.state?.shouldUploadAvatar;
  const { t, i18n } = useTranslation();
  const user = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const coverInputRef = React.useRef(null);
  const avatarInputRef = React.useRef(null);
  const blankBio = React.useRef(null);

  const handleNavigation = () => {
    if (!shouldUploadAvatar) { history.push(PROFILE, { showSavePopup: true }) }
  }

  const {
    values,
    status,
    setValues,
    setFieldValue,
    handleSubmit,
    errors,
    touched,
    handleChange,
    isSubmitting,
    setErrors,
  } = useFormik(formik({
    dispatch, history, shouldUploadAvatar, user, setShowSavePopup, afterChange: handleNavigation
  }));

  useEffect(() => {
    if (user) {
      setValues({
        name: user.name,
        nickname: user.nickname,
        subscription_price: user.subscription_price,
        about: user.about,
        subscription_message: user.subscription_message,
        location: user.location,
        website: user.website,
        avatar: { file: null, url: user.avatar },
        cover: { file: null, url: user.cover },
        id: user.id,
      });
    }
  }, [user]);

  const handleNicknameInput = e => {
    let { value } = e.target;
    if (/^[a-zA-Z]+$/.test(value)) {
      setFieldValue('nickname', value);
    }
  };
  const removeBlanks = () => {
    let textArea = blankBio.current?.value.split('\n');
    let arr = [""];
    let x = 0;

    for (let i = 0; i < textArea.length; i++) {
      if (textArea[i].trim() != "") {
        arr[x] = textArea[i];
        x++;
      }
    }
    arr = arr.join('\n');
    blankBio.current.value = arr;
    setValues(pre => ({ ...pre, about: arr }));

  }
  const handleValue = (e) => {
    if (e.target.value.length <= 6) {
      handleChange(e)

    }
    if (e.target.value.includes(".")) {
      handleChange(e)
      var subValue = e.target.value;
      let fixedValue = (subValue.indexOf(".") >= 0) ? (subValue.substr(0, subValue.indexOf(".")) + subValue.substr(subValue.indexOf("."), 3)) : t;
      setValues(pre => ({ ...pre, subscription_price: fixedValue }));
    }
  }
  const handleFileSelect = (e, target) => {
    const file = e.target.files[0];

    // File validation
    if (!file) return;

    // Check file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert(`File size too large. Maximum size is 5MB. Your file is ${(file.size / 1024 / 1024).toFixed(2)}MB.`);
      return;
    }

    // Check file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif', 'image/bmp'];
    if (!allowedTypes.includes(file.type)) {
      alert(`Invalid file type. Please select an image file (JPEG, PNG, WebP, GIF, BMP).`);
      return;
    }

    console.log(`Selected ${target} file:`, file.name, `(${file.size} bytes)`);
    setFieldValue(target, { file, url: URL.createObjectURL(file) });
  };
  return (
    <div className="col p-0 position-relative">
      <Form onSubmit={handleSubmit} className={'edit-profile-form-container'}>
        <div className="header edit-chanel-header">
          <div className="d-flex justify-content-between align-items-center offset-side-menu header-content">
            <div className="d-flex align-items-center p-3">
              <div className="hebrew-back" onClick={() => history.goBack()}>
                <NewBackIcon />
              </div>
              <div className="custom-title-container pl-4 ">{t(`edit_channel`)}</div>
            </div>
            <div>
              <ButtonComponent
                type="button"
                isWhiteText={false}
                isBold={false}
                onClick={() => {
                  console.log('Save button clicked');
                  console.log('Form values:', values);
                  console.log('Form errors:', errors);
                  console.log('Is submitting:', isSubmitting);
                  if (!isSubmitting && Object.keys(errors).length === 0) {
                    handleSubmit();
                  } else {
                    console.log('Form has errors or is submitting:', errors);
                  }
                }}
                btnText={t('SAVE')}
                transparent={true}
                customClass=" edit-profile-save-btn"
                disabled={isSubmitting}
              />
            </div>
          </div>
        </div>
        <div className=" d-flex justify-content-center cover-container-box">
          <div className={`${shouldUploadAvatar ? '' : 'd-none'} top-alert-upload-avatar`}>
            <p className="ml-3 mt-2 in_order_create_post">{t(`in_order_create_post`)}</p>
            <ul>
              <li className={`${user.avatar.includes('default-avatar.jpg') ? `` : `d-none`}`}>{t('Avatar image')} </li>
              <li className={`${user.cover.includes('default-cover.png') ? `` : `d-none`}`}>{t('Header image')}</li>
            </ul>
          </div>
        </div>
        {/**Loader for Cover Photo */}
        <Loader isLoadin={isSubmitting} height={30} size={30}>
          <div
            className="profile-header d-flex align-items-end justify-content-end"
            style={{ backgroundImage: `url('${values.cover.url}')` }}
          >
            <Form.File.Input
              onChange={e => handleFileSelect(e, 'cover')}
              style={{ display: 'none' }}
              ref={coverInputRef}
              accept=".jpg,.jpeg,.webp,.gif,.bmp,.png"
            />
            <Button
              type="button"
              onClick={() => {
                coverInputRef.current.click();
              }}
              className="btn btn-light bg-transparent font-size-12 mx-0 px-0 text-left"
              style={{ borderRadius: '32px', zIndex: 9 }}
            >
              <ChangePhotoIcon width="24" height="24" style={{ marginRight: '1em' }} />
            </Button>
          </div>

          {/** Loader for Profile Image */}
          <div
            className="col-md-9 col-12 mb-3  d-flex justify-content-center align-items-center"
            style={{
              marginTop: '-60px',
              width: '145px',
            }}
          >
            <div className="avatar-wrapper d-flex justify-content-center align-items-center position-relative">
              <Avatar style={{ fontSize: '30px' }} user={values.name} size={120} image={values.avatar.url} />
              <Button
                type="button"
                onClick={() => {
                  avatarInputRef.current.click();
                }}
                className="btn btn-primary d-flex align-items-center text-uppercase text-primary position-absolute "
                style={{
                  borderRadius: '50%',
                  padding: '10px',
                  zIndex: 9,
                  border: '2px solid #fff',
                  top: 90,
                  left: 90,
                }}
              >
                <ChangePhotoIcon width="24" height="24" />
              </Button>
            </div>

            <Form.File.Input
              onChange={e => handleFileSelect(e, 'avatar')}
              style={{ display: 'none' }}
              accept=".jpg,.jpeg,.webp,.gif,.bmp,.png"
              ref={avatarInputRef}
            />
          </div>

          <div className="col-lg-9 col-12 ">
            <div className="px-lg-5">
              <Form.Group className="my-3 ">
                <Form.Text className="text-purple ml-2 mt-0 profile-input-label pl-1 pr-1 ">{t('User Name')}</Form.Text>
                <ValidVectorIcon className={`vector  ${errors.nickname ? 'd-none' : ''}`} />
                <FormControl
                  style={{ backgroundImage: 'unset' }}
                  type="text"
                  className={` border-dark font-size-12 text-light-gray correct-direction ml-0 pl-2.5 ${errors.nickname ? 'error-border-red' : ''
                    }`}
                  name="nickname"
                  autoComplete="off"
                  value={values.nickname}
                  onChange={handleChange}
                  placeholder={t('@nathaniel111')}
                  isInvalid={touched.nickname && errors.nickname}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}

                />

                <Form.Control.Feedback style={{ position: 'inherit' }} type="invalid" tooltip>
                  {!!errors.nickname && errors.nickname}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Text className="text-purple ml-2  pl-1 pr-1 mt-0 profile-input-label">
                  {t('Display name')}
                </Form.Text>

                <FormControl
                  style={{ backgroundImage: 'unset' }}
                  type="text"
                  className={`border-dark correct-direction font-size-12 text-light-gray ml-0 pl-2.5 ${errors.name ? 'error-border-red' : ''
                    }`}
                  name="name"
                  autoComplete="off"
                  value={values.name}
                  onChange={handleChange}
                  placeholder={t('Nathan')}
                  isInvalid={touched.name && errors.name}
                  maxLength={40}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                />

                <Form.Control.Feedback style={{ position: 'inherit' }} type="invalid" tooltip>
                  {!!errors.name && errors.name}
                </Form.Control.Feedback>

                <div style={{ margin: '4px 4px 0px 0px', textAlign: 'right' }}>{values?.name?.length || 0}/40</div>
              </Form.Group>
              <Form.Group className="my-3">
                <FormControl
                  as="textarea"
                  rows="5"
                  id="textarea"
                  ref={blankBio}
                  type="text"
                  className=" border-dark font-size-12 correct-direction text-light-gray ml-0 pl-2"
                  name="about"
                  autoComplete="off"
                  maxLength={1000}
                  value={values.about}
                  onChange={handleChange}
                  placeholder={t('Bio')}
                  isInvalid={touched.about && errors.about}
                  style={{ height: '64px', paddingBottom: '35px' }}
                />
                <Form.Control.Feedback type="invalid" tooltip>
                  {!!errors.about && errors.about}
                </Form.Control.Feedback>

                <div style={{ margin: '4px 4px 0px 0px', marginRight: '4px', textAlign: 'right' }}>
                  {values?.about?.length || 0}/1000
                </div>
              </Form.Group>
              <Form.Group className="my-3">
                <FormControl
                  type="text"
                  className=" border border-dark font-size-12 correct-direction text-light-gray ml-0 pl-2"
                  name="location"
                  autoComplete="off"
                  value={values.location}
                  onChange={handleChange}
                  placeholder={t('Location')}
                  isInvalid={touched.location && errors.location}
                  maxLength={64}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}

                />
                <Form.Control.Feedback type="invalid" tooltip>
                  {!!errors.location && errors.location}
                </Form.Control.Feedback>

                <div style={{ margin: '4px 4px 0px 0px', textAlign: 'right' }}>{values?.location?.length || 0}/64</div>
              </Form.Group>

              <Form.Group className="my-3">
                <FormControl
                  type="text"
                  className=" border correct-direction border-dark font-size-12 text-light-gray ml-0 pl-2"
                  name="website"
                  autoComplete="off"
                  value={values.website}
                  onChange={handleChange}
                  placeholder={t('Website URL')}
                  isInvalid={touched.website && errors.website}
                  maxLength={100}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}

                />
                <Form.Control.Feedback type="invalid" tooltip>
                  {!!errors.website && errors.website}
                </Form.Control.Feedback>

                <div style={{ margin: '4px 4px 0px 0px', textAlign: 'right' }}>{values?.website?.length || 0}/100</div>
              </Form.Group>

              <hr style={{ marginLeft: '-20px', marginTop: '40px', marginRight: '-20px' }}></hr>

              <p
                style={{
                  fontFamily: 'inter',
                  lineHeight: '24px',
                  letterSpacing: '0.16px',
                  color: '#A6ABC9',
                  margin: '40px 0px 16px 1px',
                  fontSize: '16px',
                }}
              >
                {t('SUBSCRIPTION')}
              </p>

              <hr style={{ marginLeft: '-20px', marginRight: '-20px' }}></hr>

              <div class="form-check form-check-inline mt-3 ml-1">
                <input
                  checked={values.subscription_price === null ? true : null}
                  defaultChecked={values.isFree}
                  key={values.isFree}
                  value={values.isFree}
                  onClick={e => {
                    setValues(pre => ({ ...pre, isFree: true, subscription_price: '' }));
                  }}
                  class=" he-radio form-check-input"
                  type="radio"
                  name="isFree"
                  id="inlineRadio1"
                />
                <label class="form-check-label ml-1 " for="inlineRadio1">
                  {t('Free')}
                </label>
              </div>

              <Form.Group className="mt-2">
                <Form.Text className="text-purple ml-2 mt-0 profile-input-label pl-1 pr-1 ">
                  {t('Price per month')}
                </Form.Text>

                <FormControl
                  style={{ backgroundImage: 'unset' }}
                  className={` border-dark correct-direction font-size-12 text-light-gray ml-0 pl-2.5 ${errors.subscription_price ? 'error-border-red' : ''
                    }`}
                  name="subscription_price"
                  autoComplete="off"
                 
                 
                  value={values.subscription_price}
                  onClick={e => {
                    setValues(pre => ({ ...pre, isFree: false, subscription_price: '' }));
                  }}
                  onChange={e => {
                    handleValue(e)

                  }}
                  placeholder={values.subscription_price === null || values.isFree ? t('Free') : t('4 ₪')}
                  isInvalid={errors.subscription_price}
                  onKeyPress={(event) => {
                    if (!/^[0-9]*\.?[0-9]*$/.test(event.key) || event.key === '.' && handleDecimalDots(event.target.value, '.')) {
                      event.preventDefault();
                    }
                  }}
                />
                <Form.Control.Feedback style={{ position: 'inherit' }} type="invalid" tooltip>
                  {!!errors.subscription_price && errors.subscription_price}
                </Form.Control.Feedback>
              </Form.Group>

              {!errors.subscription_price && (
                <p className=" he-alert text-purple ml-2 " style={{ margin: '-10px 0px 40px 0px', fontSize: '12px' }}>
                  {t(`Minimum ₪ 4 NIS or free.`)} <br />{' '}
                  {t(`In order for you to withdraw your money, you first need to `)}
                  <span>
                    <Link to="#">{t(`Add your Bank information.`)}</Link>{' '}
                  </span>
                </p>
              )}
              <hr style={{ margin: '0px -20px 20px -20px' }}></hr>
            </div>
          </div>
          {errors.subscription_price ? <SubscriptionErrorPopup /> : null}
        </Loader>
      </Form>
    </div>
  );
};

export default Profile;
